import axios from '@/libs/api.request'
export const getMapping = (params) => {
  return axios.request({
    url: '/common/mapping',
    method: 'GET',
    params
  })
}
export const getDetails = (id) => {
  return axios.request({
    url: `/common/mapping/${id}`,
    method: 'GET'
  })
}
export const del = (id) => {
  return axios.request({
    url: `/common/mapping/${id}`,
    method: 'DELETE'
  })
}
export const update = (data) => {
  return axios.request({
    url: `/common/mapping/${data.id}`,
    method: 'PUT',
    data
  })
}
export const add = (data) => {
  return axios.request({
    url: '/common/mapping',
    method: 'POST',
    data
  })
}
